<template>
    <base-sheet
        id="template-sidebar"
        :title="isEdit ? $t('edit-template') : $t('add-template')"
        :ok-disabled="disabled"
        :busy="loading"
        @ok="isEdit ? updateTemplate() : addTemplate()"
        @hidden="cancelTemplate()"
    >
        <form>
            <div class="form-group text-left mb-5">
                <label for="template-name" class="font-nunito">{{$t('template-name')}}</label>
                <input
                    id="template-name"
                    type="text"
                    class="form-control font-nunito"
                    v-model=templateName
                    v-bind:placeholder="$t('template-name-placeholder')"
                    @keyup="disabled = activeBtn">
            </div>
            <div class="form-group text-left">
                <label for="template-text" class="font-nunito">{{$t('preset-message')}}</label>
                <textarea
                    id="template-text"
                    name="note"
                    class="form-control note-box w-100 mb-2 font-nunito"
                    v-model=templateText
                    rows="6"
                    v-bind:placeholder="$t('template-text-placeholder')"
                    @keyup="disabled = activeBtn"
                ></textarea>
                <sms-counter :sms="templateText" v-on:limitExceeded="smsLimitExceeded = $event"></sms-counter>
            </div>
        </form>
    </base-sheet>
</template>
<script>

// Internal componants
import Alert        from '../../helpers/Alert.js';
import SmsCounter   from '@/connectors/sms/components/SmsCounter.vue';
import BaseSheet    from '@/core/components/BaseSheet.vue';

// Import external libraries
import { mapActions, mapState } from 'vuex';
import _                        from 'underscore';
const clone = require('rfdc')();

export default {
    props: ['isEdit'],

    components: {
        BaseSheet,
        SmsCounter
    },

    data () {
        return {
            templateId:            '',
            templateName:          '',
            templateNameTemp:      '',
            templateText:          '',
            templateTextTemp:      '',
            templateUpdatableData: {},
            loading:               false,
            disabled:              true,
            smsLimitExceeded:      false
        };
    },
    computed: {
        ...mapState('core/templates', {
            templates:        'templates',
            selectedTemplate: 'selectedTemplate'
        }),

        // Validate form to activate submit form
        activeBtn () {
            if (this.isEdit) {
                return this.templateText === this.templateTextTemp && this.templateName === this.templateNameTemp;
            } else {
                return this.templateText === '' || this.templateName === '' || this.smsLimitExceeded;
            }
        },
    },
    watch: {
        /**
         * selected template watcher
         *
         * @param      {Object}  value   The value
         */
        selectedTemplate: function (value) {
            this.templateName = clone(value.attributes.name);
            this.templateText = clone(value.attributes.content);

            // Put Data on temporary variable
            this.templateNameTemp = this.templateName;
            this.templateTextTemp = this.templateText;
        }
    },

    methods: {
        ...mapActions('core/templates', {
            getTemplate:    'index',
            createTemplate: 'create',
            patchTemplate:  'update',
        }),

        /**
         * create new template
         */
        addTemplate () {
            // If template input is empty
            if (!this.templateName.length || !this.templateText.length) {
                return;
            }

            // Check if the new Template exist
            if (_.find(this.templates, template => template.attributes.name === this.templateName)) {
                Alert.fail(this.$i18n.t('template-create-error'));
                return;
            }

            // Spinner on and disable button
            this.loading  = true;
            this.disabled = true;

            // Create the new Template in db and update template Object
            this.createTemplate({
                name:    this.templateName,
                message: this.templateText
            }).then(() => {
                // Spinner off
                this.loading = false;

                // Empty the input for the template and disable button
                this.templateName = '';
                this.templateText = '';
                this.disabled     = true;
                this.$bvModal.hide('template-sidebar');
                this.getTemplate();
            });
        },

        /**
         * Send request with contact id and attributes to the api
         *
         * @param   {string}   templateId       The id of the tag.
         * @param   {object}   attributes       name and message attributes of the template
         *
         */
        updateTemplate (attributes) {
            this.loading = true;
            attributes = {
                'name':    this.templateName,
                'content': this.templateText
            };

            // Verify if template name already exist
            if (_.filter(this.templates, template => template.id !== this.selectedTemplate.id).find(template => template.attributes.name === attributes.name)) {
                Alert.fail(this.$i18n.t('template-create-error'));
                this.loading = false;
                return;
            }

            // Update template in db
            this.patchTemplate({
                id:         this.selectedTemplate.id,
                attributes: attributes
            })
                .then(() => {
                    this.templateName = '';
                    this.templateText = '';
                    this.loading      = false;
                    this.disabled     = true;
                    this.$bvModal.hide('template-sidebar');
                    Alert.success(this.$i18n.t('information-updated'));
                    this.getTemplate();
                });
        },

        /**
         * Cancel add or edit template
         * Reset values to default
         */
        cancelTemplate () {
            this.loading = false;
            this.templateId   = '';
            this.templateName = '';
            this.templateText = '';
        }
    }
};
</script>
